export const getOrgSlug = () => {
  const stored = localStorage.getItem('orgSlug')
  if (stored && stored.trim()) {
    return stored.trim()
  }

  if (process.env.VUE_APP_ORG_SLUG) {
    return process.env.VUE_APP_ORG_SLUG
  }

  const host = window.location.host
  const isLocal =
    host.startsWith('localhost') || host.startsWith('127.0.0.1')

  if (isLocal) {
    return ''
  }

  const parts = host.split('.')
  return parts[0] || ''
}

export const setOrgSlug = (slug) => {
  if (!slug) {
    return
  }
  localStorage.setItem('orgSlug', slug.trim())
}

export const clearOrgSlug = () => {
  localStorage.removeItem('orgSlug')
}
